<template>
  <component-in-worker>
    <template #icon>
      <i class="el-icon-takeaway-box"></i>
    </template>
    <h2>No Data</h2>
  </component-in-worker>
</template>

<script>
export default {
  name: "ErrorMessage",
  components: {
    ComponentInWorker: () => import("../../ComponentInWorker")
  }
};
</script>

<style></style>
